export default __webpack_public_path__ + "static/media/card-img-1.8100c18b.svg";